import React, { useEffect, useState } from 'react'
import { Tab, Tabs } from 'react-bootstrap'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import { EMPTY_OBJECT, EMPTY_ARRAY } from '../../constants/globalConstants'
import moment from 'moment'
import { checkPaymentStatus, checkStartCitationWarning, nullAndUndefinedCheck } from '../../utils/helper'
import { useNavigate, useParams } from 'react-router-dom'
import { getCitationDetails } from '../../redux/actions/citationAction'
import { Circles } from 'react-loader-spinner'


function PreviousHistory(props) {
    const { dispatch, notify, loader } = props
    const [previousHistoryData, setPreviousHistorydata] = useState(EMPTY_ARRAY)

    const { citation } = useParams()

    const navigate = useNavigate()


    useEffect(() => {
        const payload = { 'citation_number': citation }
        dispatch(getCitationDetails(payload)).then((res) => {
            if (res?.status === 201) {
                // for the citation history
                const previousHistory = {
                    'Citation History': res?.data?.citation_history,
                    'Warning History': res?.data?.warning_history,
                }
                setPreviousHistorydata(previousHistory)
                localStorage.setItem('previousHistory', JSON.stringify(previousHistory))
                localStorage.setItem('citation', citation)
            } else {
                notify('error', res?.errors?.message)
            }
        }).catch((err) => {
            notify('error', err)
        })
    }, [])

    const handleDetails = (subItem) => {
        const citationUrl = subItem?.citation_url?.split('com/')
        navigate(`/${citationUrl?.[1]}`)
    }

    const RenderSubItem = (subItem, item) => {
        const isCitationHistory = item === 'Citation History'
        return (
            <div className='card shadow border-primary mb-3 border-opacity-50' onClick={() => handleDetails(subItem)}>
                <div className='card-body'>
                    <div className='row g-0 align-items-center'>
                        <div className='col mb-2'>
                            <small className='fw-bold text-muted'>{isCitationHistory ? 'Citation Number' : 'Warning Number'}</small>
                            <h5 className='m-0 text-primary'>{isCitationHistory ? subItem?.citation_number : subItem?.warning_number}</h5>
                        </div>

                        <div className={`col-auto  px-3 py-2 bg-opacity-25 rounded text-center text-end mb-2 ${isCitationHistory ? 'bg-warning ' : 'bg-primary text-white'} `}>
                            <h6 className='m-0'>{isCitationHistory ? checkPaymentStatus('citation', subItem) : checkPaymentStatus('warning', subItem)}</h6>
                        </div>
                    </div>

                    {(nullAndUndefinedCheck(subItem?.appeal) && subItem?.appeal?.length > 0) ? subItem?.appeal?.map((item, index) => {
                        return (<div className='d-flex justify-content-between' key={index}>
                            <small className='fw-bold text-muted'>{isCitationHistory ? `${index + 1} . Appeal Status` : ''}</small>
                            <small className='fw-bold text-muted'>{isCitationHistory ? item?.appeal_message : ''}</small>
                        </div>)
                    }) : null}

                    {((isCitationHistory && subItem?.is_avoid == '1')) ? <div className='d-flex justify-content-between'>
                        <small className='fw-bold text-muted'>{isCitationHistory ? 'Void Status' : ''}</small>
                        <small className='fw-bold text-muted'>{(isCitationHistory && subItem?.is_avoid == '1') ? 'Voided' : ''}</small>
                    </div> : null}

                    {((isCitationHistory && subItem?.is_closed == '1')) ? <div className='d-flex justify-content-between'>
                        <small className='fw-bold text-muted'>{isCitationHistory ? 'Citation Status' : ''}</small>
                        <small className='fw-bold text-muted'>{(isCitationHistory && subItem?.is_closed == '1') ? 'Closed' : ''}</small>
                    </div> : null}
                </div>

                <div className='card-body p-3 py-2  d-flex bg-primary bg-opacity-10 border-top justify-content-between align-items-center'>
                    <small className='fw-bold text-muted'>Issue Date: </small>
                    <b className=' text-primary'> <i className='fa text-muted fa-clock me-1'></i> {moment(subItem?.created_at).format('MM/DD/YY - hh:mm A')}</b>
                </div>

                {(isCitationHistory) && <div className='card-footer bg-primary p-2 border-0 d-flex justify-content-between align-items-center'>
                    <b className='text-white'>Amount  </b>
                    <h6 className='m-0 text-white fw-bold'><i className='fa fa-dollar me-1'></i>{subItem?.penalty_fee}</h6>
                </div>}
            </div>
        )
    }
    return (
        loader ? <div className='d-flex justify-content-center align-items-center'> <Circles
            height="50"
            width="50"
            style={{ display: 'inline-block' }}
            color="var(--bs-primary)"
            ariaLabel="circles-loading"
            visible={true}
        /></div> : <Tabs defaultActiveKey={(checkStartCitationWarning(citation) == 'WA') ? 'Warning History' : 'Citation History'} id='justify-tab-example' variant='underline' className='m-3 nav-pills' justify>
            {Object.keys(previousHistoryData).length > 0 &&
                Object.keys(previousHistoryData)?.map((item, index) =>
                    <Tab className='p-3' key={index + 1} eventKey={item} title={item}>
                        {previousHistoryData[item]?.length > 0 ? (
                            previousHistoryData[item].map((subItem) => RenderSubItem(subItem, item))
                        ) : (
                            <p className='text-danger text-center'>No Data Available!</p>
                        )}
                    </Tab>
                )}
        </Tabs>
    )
}

PreviousHistory.propTypes = {
    dispatch: PropTypes.func,
    loader: PropTypes.bool,
    notify: PropTypes.func,
    citation_history: PropTypes.array,
    warning_history: PropTypes.array
}

PreviousHistory.defaulProps = {
    dispatch: noop,
    loader: true,
    notify: noop,
    warning_history: EMPTY_OBJECT,
    citation_history: EMPTY_OBJECT
}

function mapStateToProps({ citationReducer }) {
    return {
        loader: citationReducer?.loader,
    }
}
export default connect(mapStateToProps)(PreviousHistory)